import { useMutation } from '@apollo/react-hooks';
import { CREATE_COMPAIGN } from '../../graphql/compaign/mutation';
import {
  CreateCompaign,
  CreateCompaignVariables,
} from '../../graphql/compaign/types/CreateCompaign';
import {
  Compaigns,
  CompaignsVariables,
} from '../../graphql/compaign/types/Compaigns';
import { GET_COMPAIGNS } from '../../graphql/compaign/query';

export const useCreateCompaign = () => {
  return useMutation<CreateCompaign, CreateCompaignVariables>(CREATE_COMPAIGN, {
    onError: () => {
      // TODO: implement me
    },
    update: (client, { data }) => {
      try {
        if (!data?.createCompaign) return;

        const compaigns = client.readQuery<Compaigns, CompaignsVariables>({
          query: GET_COMPAIGNS,
        });

        client.writeQuery<Compaigns, CompaignsVariables>({
          query: GET_COMPAIGNS,
          data: {
            compaigns: {
              __typename: 'CompaignResult',
              totalCount: (compaigns?.compaigns?.totalCount ?? 0) + 1,
              compaigns: [
                data?.createCompaign,
                ...(compaigns?.compaigns?.compaigns || []),
              ],
            },
          },
        });
      } catch (e) {}
    },
  });
};
